module.exports = __webpack_public_path__ + "img/finCraft_Broker_Illustration-17.e1a124cc.png";